import React, {useEffect, useState} from 'react';
import ClockDisplay from "../ClockDisplay";
import _ from "lodash";
import Loader from "../Loader";

const SleepCard = (props) => {
    const {auth, history, isLoading} = props;
    const {facilityDetails, sectionDetails} = auth;
    const facility = facilityDetails.facilityName;
    const section = sectionDetails.sectionName;
    const [averageTime, setAverageTime] = useState(0);

    useEffect(() => {
        let averageDailySleepDuration = 0;
        let roomsWithSleep = 0;
        _.map(props.rooms, (value, key) => {
            if (value.sleep && value.sleep.sleepDataSummary && value.sleep.sleepDataSummary.totalMinutes > 0) {
                averageDailySleepDuration += value.sleep.sleepDataSummary.totalMinutes;
                roomsWithSleep++;
            }
        });
        averageDailySleepDuration /= roomsWithSleep;
        setAverageTime(averageDailySleepDuration);
    });
    return (
        <div className="card facility-sleep">
            {isLoading ? <Loader size="2x"/> : ''}
            <div className="card-header">Sleep/Rest</div>
            <div className="card-body d-flex align-items-stretch">
                <ClockDisplay
                    label="Average Estimated Sleep/Rest Time"
                    timeInMinutes={averageTime}
                />
            </div>
            <div className="px-3">
                <table className="table table-striped table-sm sleep-room-table">
                    <thead>
                        <tr>
                            <th>RESIDENT</th>
                            <th className="sleep-value-column">SLEEP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.map(props.rooms, (room, key) => (
                            <tr key={key} onClick={() => history.push(`/facilities/${facility}/sections/${section}/rooms/${room.room_id}/patient/${room.patient_id}`)}>
                                <td>{_.defaultTo(room.patient_name, key)}</td>
                                <td className="sleep-value-column">{room.sleep ? room.sleep.sleepDataSummary.formatted : '0h 0m'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SleepCard;
